<template>
  <el-image
    class="base-avatar"
    fit="fill"
    :style="{width: size, height: size, borderRadius: radius}"
    :src="src + '?imageslim'"
  >
    <div slot="error" class="">
      <div class="name-avatar" :style="{width: size, height: size, fontSize: fontSize, color: color, backgroundColor: bgColor}">
        {{ nameStr }}
      </div>
    </div>
  </el-image>
</template>

<script>

export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '50px'
    },
    color: {
      type: String,
      default: '#fff'
    },
    bgColor: {
      type: String,
      default: '#c8c8c8'
    },
    fontSize: {
      type: String,
      default: '16px'
    },
    radius: {
      type: String,
      default: '50%'
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  computed: {
    nameStr() {
      let name = this.name
      if (name.length <= 2) return name
      return name.substring(name.length - 2)
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .base-avatar{
    overflow: hidden;
  }
  .name-avatar{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: yellow;
  }
</style>
